document.documentElement.classList.remove('no-js');

(() => {
  const toggle = document.querySelector('[data-bcg-menu-toggle]');
  const menu = document.querySelector('[data-bcg-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('bcg-menu-open', open);
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bcg-menu-open');
    });
  });
})();
